/* eslint-disable sciencepo-rules/require-story */
/* Ce test avec les Carrousel */
import React from 'react';
import PropTypes from 'prop-types';
import * as bulletStyle from '../../../styles/carrousels/customBullets.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';


const CustomBullets = ({ swiper, nbBullets, total, current }) => {
  const {t} = useTranslation();
  const handleClick = (targetIndex) => {
    const currentCycle = Math.floor(current / nbBullets);
    // Calculer les chemins possibles
    const directPath = currentCycle * nbBullets + targetIndex;
    const nextCyclePath = (currentCycle + 1) * nbBullets + targetIndex;
    const prevCyclePath = (currentCycle - 1) * nbBullets + targetIndex;
    // Filtrer les chemins valides
    const validPaths = [directPath, nextCyclePath, prevCyclePath]
      .filter(path => path >= 0 && path < total);
    // Trouver le chemin le plus court
    const targetSlide = validPaths.reduce((closest, path) => {
      const currentDiff = Math.abs(path - current);
      const closestDiff = Math.abs(closest - current);
      // Si même distance, privilégier le chemin vers l'avant
      if (currentDiff === closestDiff) {
        return path > current ? path : closest;
      }
      return currentDiff < closestDiff ? path : closest;
    }, validPaths[0]);
    swiper.slideToLoop(targetSlide);
  };

  return (
    <ul className={bulletStyle.paginationContainer}>
      {Array(nbBullets).fill().map((_, index) => (
        <li
          aria-label={`${t('bullet')}${index}`}
          className={clsx(bulletStyle.bullet,
            {[bulletStyle.bulletActive]: ((current) % nbBullets) == index}
          )}
          key={`pagination-bullet-${index}`}
          onClick={() => handleClick(index)}
          role="button"
        />
      ))}
    </ul>
  );
};

export default CustomBullets;

CustomBullets.propTypes = {
  current: PropTypes.number,
  nbBullets: PropTypes.number.isRequired,
  swiper: PropTypes.object,
  total: PropTypes.number,
};